import styled from 'theme';

import { BaseItemRow, BaseItemWidth } from '../CertificatesGroup.styles';

export const CertificatesHeaderRow = styled(BaseItemRow)``;
export const CertificatesHeaderValue = styled(BaseItemWidth)`
  font-weight: ${p => p.theme.variables.fonts.weight.bold};
  font-size: ${p => p.theme.variables.fonts.size.smaller1};
  color: ${props => props.theme.variables.customColors.textColor};
  &.icon {
    width: 8%;
  }
`;
